import { useAuthStore } from "~/store/auth";
import { useOneSignalStore } from "~/store/onesignal";

export default defineNuxtRouteMiddleware(async (to, from) => {
    if(!useAuthStore().authenticated){
        // await useOneSignalStore().logout()
        return navigateTo('/auth/login')
    }
})